<template>
  <el-form :model="batchInfo"
    :disabled="isDetail"
    :rules="rules"
    ref="ruleForm"
    label-position='top'>
    <layout-card-wrap style="margin-top:15px"
      hasHeaderSlot
      v-loading="loading">
      <template slot="title">批次信息</template>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="批次号:"
            prop="batchCode">
            <span v-if="isDetail">{{batchInfo.batchCode}}</span>
            <el-input v-else
              v-model="batchInfo.batchCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品数量:"
            prop="goodsCount">
            <span v-if="isDetail">{{batchInfo.goodsCount}}</span>
            <el-input-number v-else
              :controls="false"
              style="width:100%"
              :precision="0"
              :min="1"
              :max="200000"
              v-model="batchInfo.goodsCount"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="标签数量:">
            <span v-if="isDetail">{{tagCount}}</span>
            <el-input v-else
              disabled
              placeholder="系统自动生成"
              v-model="tagCount"></el-input>
          </el-form-item>
        </el-col>
        <template v-for="(item, index) in batchInfo.baseFields">
          <el-col :span="item.type==='IMAGE' ? 24 : 8"
            :key="item.name">
            <smart-form :item="item"
              :status="isDetail ? 'detail': 'edit'"
              :vendorId="vendorId"
              :tradeType="tradeType"
              :productId="productId"
              :prop="'baseFields.' + index + '.fieldValue'" />
          </el-col>
        </template>
        <template v-for="(item, index) in batchInfo.extraFields">
          <el-col :span="item.type==='IMAGE' ? 24 : 8"
            :key="item.name">
            <smart-form :item="item"
              :status="isDetail ? 'detail': 'edit'"
              :vendorId="vendorId"
              :prop="'extraFields.' + index + '.fieldValue'" />
          </el-col>
        </template>
      </el-row>
    </layout-card-wrap>
  </el-form>
</template>

<script>
import '@/components/business/custom-form/index'
import TemplateFormat from '@/utils/templateFormat'
import clonedeep from 'lodash.clonedeep'
// 非企业定制 产品码 -出库赋码

export default {
  name: 'batch-form-pm-ck',
  components: {},
  props: {
    isDetail: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    batch: {
      type: Object,
      default () {
        return {}
      }
    },
    vendorId: Number,
    productId: [String, Number],
    tradeType: [String, Number]
  },
  data () {
    return {
      batchInfo: {
        batchCode: '',
        goodsCount: null,
        baseFields: [],
        extraFields: []
      },
      rules: {
        batchCode: [
          { required: true, message: '请输入批次号', trigger: 'blur' },
          { max: 20, message: '长度最多 20 个字符', trigger: 'blur' }
        ],
        goodsCount: [
          { required: true, message: '请输入商品数量', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    batch: {
      handler (val, oldVal) {
        this.batchInfo = clonedeep(val)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tagCount () {
      return this.batchInfo.goodsCount
    }
  },
  methods: {
    submit (callback) {
      this.$refs.ruleForm.validate(valid => {
        console.log(valid)
        if (valid) {
          let data = {
            batchCode: this.batchInfo.batchCode,
            goodsCount: this.batchInfo.goodsCount,
            tagCount: this.tagCount,
            baseFields: TemplateFormat.submitTemplateFormat(clonedeep(this.batchInfo.baseFields)),
            extraFields: TemplateFormat.submitTemplateFormat(clonedeep(this.batchInfo.extraFields))
          }
          callback(data)
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
